/**
 * @summary Functions specific to the login page
 * @file
 */

import { add_deviceprint } from "@/common/browserFingerprint.js"
import { aspControlValidationInit, customValidationInit } from "@/common/validation/init.js";

/**
 * @summary Show an alert if cookies are disabled
 */
function alertIfCookiesDisabled() {
  if (!navigator.cookieEnabled) {
    alert("You need to enable cookies for this site to load properly.")
  }
}

/**
 * @summary Do everything needed to show the login page.
 */
export function InitializeLoginPage() {
  customValidationInit(false);
  aspControlValidationInit();
  $(document).tooltip();

  // Populate the device print
  $("[id$='hdndevicePrint']").val(add_deviceprint());

  alertIfCookiesDisabled();
}
